import { FC } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { TextareaField as DSTextareaField, FieldChangeEvent, Text } from '@frontend/design-system';

const DEFAULT_MAX_LENGTH = 1000;

const fieldLabelTextStyle = css`
  display: block;
  margin-bottom: ${theme.spacing(0.5)};
`;

const characterCounterStyle = css`
  display: block;
  margin-top: ${theme.spacing(0.5)};
`;

const errorMessageStyle = css`
  display: block;
  margin-top: ${theme.spacing(0.5)};
  color: ${theme.colors.text.critical};
`;

export interface TextareaFieldProps {
  id: string;
  name: string;
  label: string;
  active: boolean;
  'aria-invalid': boolean;
  touched: boolean;
  error?: string;
  onBlur: () => void;
  onChange: (e?: FieldChangeEvent) => void;
  onFocus: () => void;
  value: string;
}

export const TextareaField: FC<TextareaFieldProps> = ({
  id,
  name,
  label,
  active,
  'aria-invalid': ariaInvalid,
  touched,
  error,
  onBlur,
  onChange,
  onFocus,
  value,
}) => {
  const maxLength = DEFAULT_MAX_LENGTH;
  const currentLength = value.length;
  const remainingChars = maxLength - currentLength;
  const hasError = touched && !!error;

  return (
    <>
      {/* TODO: Fix accessibility issue */}
      {label && (
        <Text weight='regular' css={fieldLabelTextStyle}>
          {label}
        </Text>
      )}
      <DSTextareaField
        id={id}
        name={name}
        label=''
        active={active}
        aria-invalid={ariaInvalid}
        autoGrow={[2, 5]}
        touched={touched}
        error=''
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        value={value}
        maxLength={maxLength}
      />
      <Text color='subdued' size='small' css={characterCounterStyle}>
        {remainingChars} / {maxLength}
      </Text>
      {hasError && (
        <Text size='small' css={errorMessageStyle}>
          {error}
        </Text>
      )}
    </>
  );
};
